export default __webpack_public_path__ + "a84688ad3415866a3e0d55fb9b0f1d16.png";